import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import Input from '../../../../module/input'
import history from '../../../../route/history'
import InboxFormNew1 from '../inbox/form/InboxFormNew1'
import InboxFormNew2 from '../inbox/form/InboxFormNew2'
import InboxFormNew3 from '../inbox/form/InboxFormNew3'
import { alertActions, inboxActions, sentActions } from '../../../../store/actions'
import { commons } from '../../../../hook/common'
import ServiceDashboard from '../../../../layout/service/ServiceDashBoard' // 2021.06 DashBoard 추가

const CertificateSentDetail = (props) => {
  const queryString = require('query-string')
  const [state, setState] = useState({})
  const [historyInfo, setHistoryInfo] = useState({})
  const [sentInfo, setSentInfo] = useState({})
  const [inboxTransSts, setInboxTransSts] = useState('')

  useEffect(() => {
    const locationInfo = props.location.state

    locationInfo &&
      setHistoryInfo({
        ...historyInfo,
        selectedSubject: locationInfo?.selectedSubject,
        tabStatus: locationInfo?.tabStatus,
        srhFrom: locationInfo?.srhFrom,
        srhTo: locationInfo?.srhTo,
        srhKeyword: locationInfo?.srhKeyword,
        pageIdx: locationInfo?.pageIdx || 0,
      })

    if (props.match.params.seq) {
      let crtRcvSeq = props.match.params.seq
      props.getSentInfo(crtRcvSeq)
    }
  }, [])

  useEffect(() => {
    if (props.isCollect) {
      // 수신함 회수 성공
      goList()
    } else {
      // 변경 실패
    }
  }, [props.isCollect])

  const goList = (e) => {
    e.preventDefault()
    let paramStr = queryString.stringify(historyInfo)
    paramStr.length > 0 && (paramStr = '?' + paramStr)
    history.push('/service/sent' + paramStr)
  }

  useEffect(() => {
    if (props.sentInfo) {
      setSentInfo(props.sentInfo)
      setInboxTransSts(props.sentInfo?.transSts)
    } else {
    }
  }, [props.sentInfo])

  useEffect(() => {}, [props.isSubDoc])

  const onCollection = () => {
    props.onCollection(sentInfo.crtRcvSeq)
  }

  const onDropDown = () => {
    setState({
      ...state,
      isToggle: !state.isToggle,
    })
  }

  const onPDFView = () => {
    const fileList = props.sentInfo?.fileList

    //파일 이관 체크
    if (inboxTransSts === '01') {
      props.subSentDocPdf(props.sentInfo?.crtSeq)

      props.success({
        title: '증명서 이관 요청',
        message: '증명서 보관기관이 경과되어 파일이 이관되었습니다.\n재이관을 요청하였으며 10분 정도 소요됩니다.',
      })

      goList()

      return
    } else if (inboxTransSts === '02') {
      if (fileList != null) {
        props.success({
          title: '증명서 이관 요청중',
          message: '증명서 보관기관이 경과되어 파일이 이관되었습니다.\n재이관을 요청하였으며 10분 정도 소요됩니다.',
        })
        return
      } else {
        commons.openSubmitPdf(props.sentInfo?.crtSeq)
      }
    } else {
      if (!fileList) {
        props.error({ message: 'PDF 파일이 존재하지 않습니다.' })
        return
      }
      //열지말고 다운으로 수정
      // commons.openPdf(fileList[0].fileId);

      let anchor = document.createElement('a')
      anchor.style = 'display:none;'
      document.body.appendChild(anchor)

      fileList.forEach((val, idx, arr) => {
        setTimeout(() => {
          let url = process.env.REACT_APP_API_URL + '/portal/file/general/' + fileList[idx].encryptedId
          anchor.href = url
          anchor.click()
        }, 20)
      })
      document.body.removeChild(anchor)
    }
  }

  return (
    <>
      <div className="ServiceDashboard">
        <ServiceDashboard />
      </div>
      {/* <!-- contents --> */}
      <div id="contents">
        <div className="content-header">
          <a href="#" className="page-prev" onClick={goList}>
            뒤로이동
          </a>
          {/* <!-- mobile --> */}
          <h2>간접수출증명서</h2>
          <div className="breadcrumb">
            <span>Home</span>
            <span>전자문서지갑</span>
            <em>간접수출증명서</em>
          </div>
        </div>
        {props.sentInfo?.crtCd === '01' && <InboxFormNew1 data={props.sentInfo} goList={goList} onPDFView={onPDFView} />}
        {props.sentInfo?.crtCd === '02' && <InboxFormNew2 data={props.sentInfo} goList={goList} onPDFView={onPDFView} />}
        {/*  {
                        props.sentInfo?.crtCd === '03' &&
                        <InboxFormNew3 data={props.sentInfo} goList={goList} onPDFView={onPDFView}/>
                    } */}
      </div>
      {/* //contents */}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    sentInfo: state.sent?.sentInfo,
    pdfString: state.inbox?.pdfString,
    isCollect: state.sent?.isCollect,
    isSubDoc: state.sent?.isSubDoc,
  }
}

const actionCreators = {
  getSentInfo: sentActions.getSentInfo,
  success: alertActions.success,
  error: alertActions.error,
  getPdfString: inboxActions.getPdfString,
  initPdfFlag: inboxActions.initPdfFlag,
  onCollection: sentActions.onCollection,
  subSentDocPdf: sentActions.subSentDocPdf,
}

export default connect(mapStateToProps, actionCreators)(CertificateSentDetail)
